import React from "react";
import logo from "images/ESGLogo.png";
import "./Loading.css";

const PageHeader = props => (
  <Segment>
    <Container>
      <img src={logo} alt="Logo" style={{ width: 80 }} />
    </Container>
  </Segment>
);
const Segment = props => (
  <div style={{ padding: "1rem", backgroundColor: "#1b1c1d" }}>
    {props.children}
  </div>
);
const Container = props => (
  <div style={{ width: 723, marginLeft: "auto", marginRight: "auto" }}>
    {props.children}
  </div>
);
const Message = props => <div className="message">{props.children}</div>;

const Loader = props => (
  <div
    style={{
      alignItems: "center",
      backgroundColor: "#1b1c1d",
      display: "flex",
      height: "100vh",
      justifyContent: "center",
      width: "100vw"
    }}
  >
    <div className="spinner" />
  </div>
);

const Loading = props => {
  if (props.isLoading) {
    // While our other component is loading...
    if (props.timedOut) {
      // In case we've timed out loading our other component.
      return (
        <React.Fragment>
          <PageHeader />
          <Container>
            <p>{`This is taking longer than expected. Please standby.`}</p>
          </Container>
        </React.Fragment>
      );
    } else if (props.pastDelay) {
      // Display a loading screen after a set delay.
      return <Loader />;
    } else {
      // Don't flash "Loading..." when we don't need to.
      return null;
    }
  } else if (props.error) {
    // If we aren't loading, maybe
    console.error(props.error);
    return (
      <React.Fragment>
        <PageHeader />
        <Container>
          <p
          >{`Now it's really messed up. The application has failed to load. This is usually a temporary issue caused by a problem with the network.`}</p>
          <p>{`Try:`}</p>
          <ul>
            <li>{`Checking your internet or wifi connection`}</li>
            <li>{`Reloading this page`}</li>
            <li
            >{`Contacting your service provider if you continue to see this message`}</li>
          </ul>
          <hr />
          <Message>
            <p>{`The error is:`}</p>
            <p>{props.error.message}</p>
          </Message>
        </Container>
      </React.Fragment>
    );
  } else {
    // This case shouldn't happen... but we'll return null anyways.
    return null;
  }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/services/route-loader/Loading.js